import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const InfoCard = ({ fontawesomeIconName, infotext, color, b2b }) => {
  return (
    <div className="flex md:items-center space-x-3 md:space-x-6 space-y-0">
      <FontAwesomeIcon
        icon={fontawesomeIconName}
        className="text-base text-black mt-1.5 md:mt-0"
      />
      <div
        className={`${
          b2b ? "text-[14px]" : "text-[14px]"
        } font-sans text-slate-900 font-normal py-0.5`}
      >
        {infotext}
      </div>
    </div>
  );
};

export default InfoCard;
